import { useInView } from "framer-motion";
import { useRef } from "react";

export function LoadIfInView(props: { children: React.ReactNode }) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    amount: "some",
  });

  return <div ref={ref}>{isInView && props.children}</div>;
}
